import { css } from "@emotion/css";
import { THEME_COLOR } from "../../styles/colors";

// Waveform image with an optional icon in a 64px white circle hanging half below it.
// left: 37 puts a 32px icon at the content column's 64px indent. The wrapper is the anchor.
export const waveformClass = css({
  position: "relative",
  "& > div": {
    position: "absolute",
    bottom: -32,
    left: 37,
    width: 64,
    height: 64,
    borderRadius: "50%",
    backgroundColor: THEME_COLOR.WHITE,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
});
